import IMask from "imask";

export function phoneMask(element) {
    const phoneMask = IMask(element, {
        mask: "(00) 0000[0]-0000",
    });

    element.addEventListener("keyup", function () {
        if (this.value.length === 14) {
            phoneMask.updateOptions({
                mask: "(00) 0000-0000[0]",
            });
        } else if (this.value.length === 15) {
            phoneMask.updateOptions({
                mask: "(00) 00000-0000",
            });
        }
    });
}
